<template>
    <ul class="form-field__list">
        <li v-for="option of attributes" :key="option.alias" :class="['form-field__list-item', {'form-field__list-item--disabled': option.isDisabled && !hideDisabled}]">
            <input type="radio" :id="`option-${option.alias}`" @click="selectOption(option)" v-model="currentModel" :value="option.alias" :disabled="option.isDisabled  && !hideDisabled"/>
            <label :for="`option-${option.alias}`">
                <span class="option__label"> {{ option.info && option.info.title ? option.info.title : option.name }} </span>
                <!-- <button v-if="option.info && option.info.description" class="product-more-info" @click="showInfoModal(option.info.description)">
                    <svg xmlns="http://www.w3.org/2000/svg" height="22" viewBox="0 -960 960 960" width="22"><title>More Info</title><path d="M450.001-290.001h59.998V-520h-59.998v229.999ZM480-588.461q13.731 0 23.019-9.288 9.288-9.288 9.288-23.019 0-13.73-9.288-23.019-9.288-9.288-23.019-9.288-13.731 0-23.019 9.288-9.288 9.289-9.288 23.019 0 13.731 9.288 23.019 9.288 9.288 23.019 9.288Zm.067 488.46q-78.836 0-148.204-29.92-69.369-29.92-120.682-81.21-51.314-51.291-81.247-120.629-29.933-69.337-29.933-148.173t29.92-148.204q29.92-69.369 81.21-120.682 51.291-51.314 120.629-81.247 69.337-29.933 148.173-29.933t148.204 29.92q69.369 29.92 120.682 81.21 51.314 51.291 81.247 120.629 29.933 69.337 29.933 148.173t-29.92 148.204q-29.92 69.369-81.21 120.682-51.291 51.314-120.629 81.247-69.337 29.933-148.173 29.933ZM480-160q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>
                </button> -->
            </label>
        </li>
    </ul>
</template>
<script>

import { ref, watch  } from 'vue';

// const InfoModal = () => import(/* webpackChunkName: 'info-modal' */ '../../InfoModal');

export default {
  emits: ["change"],
  props: {
    model: {
      required: true
    },
    attributes: {
      type: Array,
      required: true
    },
    hideDisabled: {
      type: Boolean,
      default: false,
    }
  },
  setup(props, {emit}) {
    const currentModel = ref(props.model);
    const hideDisabled = ref(props.hideDisabled);
    const attributes = ref(props.attributes);

    const selectOption = (option) => {
      currentModel.value = option.alias;
      handleChange();
    };

    const handleChange = () => {
      emit('change', currentModel.value);
    };

    watch(() => props.model, (newValue) => {
      currentModel.value = newValue;
    });

    return {
      selectOption,
      currentModel,
      hideDisabled,
      attributes
    }
  },
};
</script>